import { connect } from 'react-redux';
import CourseDetail from './CourseDetailPage';
import { createSelector } from 'redux-orm';
import { orm, dbStateSelector } from 'db';
import { courseSelectorFnMaker } from './CourseDetailSelectors';
import { courseDetailActions } from './CourseDetailActions';

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id;
    const courseSelector = createSelector(orm, dbStateSelector, courseSelectorFnMaker(id));
    return {
        course: courseSelector(state),
    }
};

const mapDispatchToProps = dispatch => ({
    initData: (id) => {
        return dispatch(courseDetailActions.getCourseFromApi(id));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseDetail);